document.querySelectorAll(".qty-control").forEach((control) => {
  const input = control.querySelector(".qty-input");
  const btnMinus = control.querySelector(".minus");
  const btnPlus = control.querySelector(".plus");

  btnMinus.addEventListener("click", () => {
    let val = parseInt(input.value, 10) || 1;
    if (val > parseInt(input.min || 1, 10)) {
      input.value = val - 1;
    }
  });

  btnPlus.addEventListener("click", () => {
    let val = parseInt(input.value, 10) || 1;
    input.value = val + 1;
  });
});
